"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSearchHeading = exports.getSearchtype = void 0;
exports.getSearchtype = function (state) { return state.hfilter.listingType; };
exports.getSearchHeading = function (state) { return state.heading ? state.heading.heading
    .split(' ').slice(1).join(' ') : ''; };
